import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Visibility(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M5.624 14.781A21.709 21.709 0 013.216 12c.455-.627 1.3-1.71 2.408-2.781C7.386 7.515 9.642 6 12 6c2.358 0 4.614 1.515 6.376 3.219A21.713 21.713 0 0120.784 12a21.71 21.71 0 01-2.408 2.781C16.614 16.485 14.358 18 12 18c-2.358 0-4.614-1.515-6.376-3.219zm16.382-4.485c.291.378.578.763.836 1.165 0 0 .158.223.158.539 0 .316-.158.54-.158.54-.258.402-.544.786-.836 1.164a23.526 23.526 0 01-2.24 2.515C17.91 18.015 15.165 20 12 20s-5.909-1.985-7.766-3.781a23.522 23.522 0 01-2.852-3.347c-.498-.716-.537-.972 0-1.744a23.526 23.526 0 012.851-3.347C6.092 5.985 8.836 4 12 4s5.909 1.985 7.766 3.781a23.53 23.53 0 012.24 2.515zM14 12a2 2 0 11-4 0 2 2 0 014 0zm2 0a4 4 0 11-8 0 4 4 0 018 0z",
    clipRule: "evenodd"
  }));
}

export default Visibility;